import { isPresent } from '../../commonv3/utils/presence';

export function checkState(condition: boolean, message?: string) {
    if (condition) {
        return;
    }
    throw new Error(message || 'Precondition failed');
}

export function checkPresent(value: any, message?: string) {
    if (isPresent(value)) {
        return;
    }
    throw new Error(message || 'value must  exist');
}
